import {EVENT_ACTION, Transaction, Product} from 'progressive-web-sdk/dist/analytics/data-objects/'

export const sendCartEvent = (cartAction, updatedCartQty = 0) => {
    setTimeout(() => {
        // Expecting the sandy object to be initialized already by loader.js
        if (!window.sandy) {
            console.error('Sandy is not available')
            return
        }

        window.sandy('set', 'cart_items', updatedCartQty)
        window.sandy('send', 'event', 'timing', cartAction)

        // NOTE
        // Looking at past implementations, the bare minimum data to send is only `cart_items`:
        // https://github.com/mobify/lancome-analytics/blob/master/config/config.js
        // https://github.com/mobify/analytics-sdk/blob/78bd78b58eac0c10bb91993f26195916ccbeef82/src/integrations/sandy.js#L45
    })
}

// Mimicking the Engagement Engine connector:
// https://github.com/mobify/progressive-web-sdk/blob/19cbfc1721a12ee83d049724058b311e0b55a853/src/analytics/connectors/engagement-engine/connector.js#L294
export const sendPurchaseEvent = (purchase) => {
    setTimeout(() => {
        // Expecting the sandy object to be initialized already by loader.js
        if (!window.sandy) {
            console.error('Sandy is not available')
            return
        }

        const purchaseInfo = new Transaction(
            purchase.transaction,
            purchase.products,
            [Transaction.REVENUE],
            [Product.PRICE, Product.QUANTITY],
            {
                id: {
                    name: 'transaction_id'
                }
            },
            {
                id: {
                    name: 'product_id'
                }
            }
        , false)

        purchaseInfo.products.forEach((product) => {
            window.sandy('send', 'event', {
                eventCategory: 'ecommerce',
                eventAction: `${EVENT_ACTION.purchase}.product`,
                // product dimensions below
                transaction_id: purchaseInfo.transaction.transaction_id,
                ...product
            })
        })

        window.sandy('send', 'event', {
            eventCategory: 'ecommerce',
            eventAction: EVENT_ACTION.purchase,
            // transaction dimensions below
            ...purchaseInfo.transaction
        })
    })
}



// WEBPACK FOOTER //
// ./non-pwa/engagement-engine-analytics.js